// extracted by mini-css-extract-plugin
export default {"popup":"card_popup__nK5Bq","defaultCard":"card_defaultCard__HWPIl","empty":"card_empty__6HNVp","modalCard":"card_modalCard__JQiw9"};